module.exports = __webpack_public_path__ + "img/cgreen_drum.cc8b0740.svg";